import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';

import { FormHelper } from '../../helpers/form-helper';
import { Application } from '../../models/application';
import { ApplicationService } from '../../services/application.service';

@Component({
  selector: 'app-check-in-application',
  templateUrl: './check-in-application.component.html',
  styleUrls: ['./check-in-application.component.scss']
})
export class CheckInApplicationComponent extends FormHelper implements OnInit {
	private application: Application;

  constructor(private dialogRef: MdDialogRef<CheckInApplicationComponent>,
							private formBuilder: FormBuilder,
							private applicationService: ApplicationService) {
		super();

		this.buildForm();
	}

  ngOnInit() {
  }

	public buildForm(): void {
		this.form = this.formBuilder.group({
			consecutive: new FormControl('', Validators.required),
			bedroom: new FormControl('', Validators.required)
		});
	}

	public updateForm(application: Application): void {
		this.application = application;
	}

	public submitForm(): void {
		let application: Application = this.form.value;
		this.application.consecutive = application.consecutive;
		this.application.bedroom = application.bedroom;

		this.applicationService.updateApplication(this.application.$key, this.application);

		this.dialogRef.close();
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/check-in-application/check-in-application.component.ts